module.exports = __webpack_public_path__ + "media/images/page/step_img01-339946c0c7beedb105e5101c51364ae5.svg";